export default __webpack_public_path__ + "7883e41d63ba1d9a47cafebda4afd07c.svg";